import { render, staticRenderFns } from "./new-payment-gateway-form.vue?vue&type=template&id=60561f1a&"
import script from "./new-payment-gateway-form.vue?vue&type=script&lang=js&"
export * from "./new-payment-gateway-form.vue?vue&type=script&lang=js&"
import style0 from "./new-payment-gateway-form.vue?vue&type=style&index=0&id=60561f1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports